import React from 'react';
import EmptyPage from './EmptyPage';
import NoSurveyDataImage from '../assets/images/emptyPages/NoSurveyData.svg';
import { getTranslation } from '../locales';

interface NoSurveyDataPageProps {
  locale?: string;
}

const NoSurveyDataPage: React.FC<NoSurveyDataPageProps> = ({ locale = "en" }) => {
  const t = getTranslation(locale);
  
  return (
    <EmptyPage
      message={t.noSurveyAvailable}
      subMessage={t.surveyNotFound}
      image={NoSurveyDataImage}
    />
  );
};

export default NoSurveyDataPage;
